import Footer from '../components/public/Footer';
import Header from '../components/public/Header';

export default function PublicLayout({ children }) {
    return (
        <>
            <div className="app__header">
                <Header />
            </div>
            <div className="app__content">
                {children}
            </div>
            <div className="app__footer">
                <Footer />
            </div>
        </>
    );
}
